import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { MatSpinner } from '@angular/material/progress-spinner';

import { Observable, Subject } from 'rxjs';
import { mapTo, scan, map, distinctUntilChanged } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class ProgressSpinnerService {
  private spinnerTopRef: OverlayRef;
  private activeRequestCount = 0;
  private watchdogTimer: any = null;
  private readonly watchdogMs = 30000;

  private spin$: Subject<number> = new Subject();

  constructor(private overlay: Overlay, private spinner: NgxSpinnerService) {
    this.spinnerTopRef = this.overlay.create({
      hasBackdrop: true,
      positionStrategy: this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically(),
    });

    this.spin$
      .asObservable()
      .pipe(
        scan((acc, next) => {
          if (!next) {
            return 0;
          }
          return acc + next >= 0 ? acc + next : 0;
        }, 0),
        map((val) => val > 0),
        distinctUntilChanged()
      )
      .subscribe((res) => {
        if (res) {
          this.spinnerTopRef.attach(new ComponentPortal(MatSpinner));
        } else if (this.spinnerTopRef.hasAttached()) {
          this.spinnerTopRef.detach();
        }
      });
  }
  // tslint:disable-next-line: typedef
  show() {
    this.activeRequestCount += 1;
    this.startWatchdog();
    if (this.activeRequestCount === 1) {
      this.spinner.show();
    }
  }
  // tslint:disable-next-line: typedef
  hide() {
    this.activeRequestCount =
      this.activeRequestCount > 0 ? this.activeRequestCount - 1 : 0;

    if (this.activeRequestCount === 0) {
      this.clearWatchdog();
      this.spinner.hide();
    }
  }
  // tslint:disable-next-line: typedef
  reset() {
    this.activeRequestCount = 0;
    this.clearWatchdog();
    this.spinner.hide();
  }

  private startWatchdog(): void {
    this.clearWatchdog();
    this.watchdogTimer = setTimeout(() => {
      this.reset();
    }, this.watchdogMs);
  }

  private clearWatchdog(): void {
    if (this.watchdogTimer) {
      clearTimeout(this.watchdogTimer);
      this.watchdogTimer = null;
    }
  }
}
